document.addEventListener("DOMContentLoaded", function () {

  // ✅ 1. Open / Close mobile submenu
  document.querySelector('.menu-drawer__navigation').addEventListener('click', function(event) {
    const target = event.target.closest('.main-mega-menu-item');
    if (target) {
      const submenu = target.parentElement.querySelector('.menu-list__submenu');
      if (submenu) submenu.classList.add('open-mob-submenu');
    }
  });

  // ✅ 3. Wishlist header icon
  const wishlistHeader = document.querySelector('xb-wishlist-header-icon');
  if (wishlistHeader) {
    document.querySelector('#header-wisharea').innerHTML = wishlistHeader.outerHTML;
  }

  // ✅ 4. Wishlist sticky nav icon
  if (wishlistHeader) {
    document.querySelector('#sticky-nav-wishlist').innerHTML = wishlistHeader.outerHTML;
  }

  // ✅ 12. Add class on account create
  document.querySelectorAll('.create-account').forEach(el => el.classList.add('account'));

  // ✅ 14. Open menu drawer
  const hamburger = document.querySelector('svg.icon.icon-hamburger');
  if (hamburger) {
    hamburger.addEventListener('click', () => {
      const drawer = document.querySelector('#Details-menu-drawer-container');
      if (drawer) {
        drawer.classList.add('menu-opening');
        drawer.setAttribute('open', 'open');
      }
      const menuIcon = document.querySelector('.header__icon--menu');
      if (menuIcon) menuIcon.setAttribute('aria-expanded', 'true');
      document.querySelector('header').classList.add('site-header-transparent-drawer');
    });
  }

  // ✅ 15. Close menu drawer
  const closeIcon = document.querySelector('.header__icon--menu svg.icon.icon-close');
  if (closeIcon) {
    closeIcon.addEventListener('click', () => {
      const drawer = document.querySelector('#Details-menu-drawer-container');
      if (drawer) {
        drawer.classList.remove('menu-opening');
        drawer.removeAttribute('open');
      }
      const menuIcon = document.querySelector('.header__icon--menu');
      if (menuIcon) menuIcon.setAttribute('aria-expanded', 'false');
      document.querySelector('header').classList.remove('site-header-transparent-drawer');
    });
  }

}); // DOMContentLoaded


